export const environment = {
  API_ENDPOINT: process.env.REACT_APP_END_POINT,
  AppName: process.env.REACT_APP_NAME,
  Bearer: process.env.REACT_APP_BEARER,
};
